module.exports = __webpack_public_path__ + "static/media/3-1.3ae5d4f8.png";